/**
 * List of states for a distribution
 */
export enum DistributionState {
    Requested = 'Requested',
    Submitted = 'Submitted',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Funded = 'Funded'
}